module.exports = __webpack_public_path__ + "static/img/Logo2.95cbf2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo2.png
// module id = ZWRV
// module chunks = 8